import React from "react";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import EditAgentMessage from "./EditAgentMessage";
import { useLocation,useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { configData } from "../config";

const ViewAgentMessage = ({ savedData }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [detailedview, setDetailedView] = useState({});
    var {tab} = useParams();
    const app_url = configData.APP_URL;
   
    const {aid} = useParams();

    useEffect(() => {
         Promise.all([
          retrieveEditAgentMessage()
          ]).then(() => {
     
            setIsLoading(false);
           
          })
       
     
    },[]);
 async function  retrieveEditAgentMessage() {
        const response = await fetch(
        app_url+'smwwagency/retrieveagentmessage?id='+aid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            setDetailedView(
                {
                   body: responsedata.data.result.editbody
                }
            );
           console.log(detailedview);
           

        }
    }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (   
                     
                <div>
                     
                    <div className="view-agent-msg-container">
                        <div dangerouslySetInnerHTML={{ __html: detailedview.body }} />
                    </div>
                </div>
            )}
        </>
    );
};
export default ViewAgentMessage;